import {Action} from "redux-actions";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import Task from "../../../model/task/Task";
import {TASK_CREATED, TASK_UPDATED, TASKS_FETCHED} from "./actionType";

/**
 * Tasks fetched successful action.
 * @param {Array<Task>} tasks all tasks from server.
 * @returns {Action<TASKS_FETCHED>}
 */
function tasksFetched(tasks: Array<Task>): Action<TASKS_FETCHED> {
	return {type: TASKS_FETCHED, payload: {tasks}};
}

/**
 * Task created successful action
 * @param {Task} task
 * @returns {Action<TASK_CREATED>}
 */
function taskCreated(task: Task): Action<TASK_CREATED> {
	return {type: TASK_CREATED, payload: {task}};
}

/**
 * Task updated successful action
 * @param {Task} task
 * @returns {Action<TASK_CREATED>}
 */
function taskUpdated(task: Task): Action<TASK_UPDATED> {
	return {type: TASK_UPDATED, payload: {task}};
}

/**
 * Fetch tasks from server.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchTasks(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.taskApi.fetchTasks().then(tasks => {
			dispatch(tasksFetched(tasks));
			onSuccess();
		}).catch(onFailure);
	};
}

/**
 * Create task.
 * @param task
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function createTask(task: Task, onSuccess: OnSuccessData<Task>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.taskApi.createTask(task).then(t => {
			dispatch(taskCreated(t));
			onSuccess(t);
		}).catch(onFailure);
	};
}

/**
 * Update task.
 * @param taskId
 * @param task
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateTask(taskId: string, task: Task, onSuccess: OnSuccessData<Task>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.taskApi.updateTask(taskId, task).then((t) => {
			dispatch(taskUpdated(t));
			onSuccess(t);
		}).catch(onFailure);
	};
}
